import { styled } from '@linaria/react';

export const StyledXLarge = styled.h1`
  font-family: Inter, sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
`;

export const StyledH1 = styled.h1`
  font-family: Inter, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;
`;

export const StyledH2 = styled.h2`
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
`;

export const StyledH3 = styled.h3`
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
`;

export const StyledH4 = styled.h4`
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const StyledH5 = styled.h5`
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
`;

export const StyledH6 = styled.h6`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
`;

export const StyledSpan = styled.span`
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
`;

export const StyledParagraph = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
`;

export const StyledSmall = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
`;

export const StyledMedium = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
`;

export const StyledSpanSmall = styled.span`
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
`;
